import type {ReactNode} from 'react'

export function MetricTile({
  label,
  value,
  detail,
  accent = 'default',
}: {
  label: string
  value: ReactNode
  detail?: ReactNode
  accent?: 'default' | 'green' | 'amber' | 'red'
}) {
  return (
    <article className={`metric-tile metric-${accent}`}>
      <span className="metric-label">{label}</span>
      <strong className="metric-value">{value}</strong>
      {detail ? <span className="metric-detail">{detail}</span> : null}
    </article>
  )
}
